import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { getStoredStopId, hasStoredStopId, withStoredStopId } from "@catchy/app-core";
const fallbackLabels = {
  inbound: "Inbound",
  outbound: "Outbound"
};
const SegmentedButton = t0 => {
  const $ = _c(8);
  const {
    label,
    direction,
    togglePreferredDirection,
    directionTo
  } = t0;
  const t1 = direction === directionTo;
  let t2;
  if ($[0] !== directionTo || $[1] !== togglePreferredDirection) {
    t2 = () => togglePreferredDirection(directionTo);
    $[0] = directionTo;
    $[1] = togglePreferredDirection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `z-10 flex-1 rounded-full p-1 outline-none ring-blue-500/50 transition-colors motion-reduce:transition-none focus-visible:ring ${direction === directionTo ? "font-bold" : "font-normal hover:bg-zinc-400/10"}`;
  let t4;
  if ($[3] !== label || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <button type="button" aria-pressed={t1} onClick={t2} className={t3}>{label}</button>;
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default function DirectionControl(t0) {
  const $ = _c(25);
  const {
    direction,
    setDirection,
    preferredDirections,
    setPreferredDirections,
    stopId,
    directionLabels
  } = t0;
  const labelId = useId();
  let t1;
  if ($[0] !== preferredDirections || $[1] !== setDirection || $[2] !== setPreferredDirections || $[3] !== stopId) {
    t1 = value => {
      setDirection(value);
      const updatedPreferredDirections = preferredDirections.some(el_0 => hasStoredStopId(el_0, stopId)) ? preferredDirections.map(el => hasStoredStopId(el, stopId) ? withStoredStopId({
        ...el,
        direction: value
      }, stopId) : el) : [...preferredDirections, withStoredStopId({
        direction: value
      }, stopId)];
      setPreferredDirections(updatedPreferredDirections.filter(_temp));
    };
    $[0] = preferredDirections;
    $[1] = setDirection;
    $[2] = setPreferredDirections;
    $[3] = stopId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const togglePreferredDirection = t1;
  const indicatorPosition = direction === "inbound" ? "translate-x-0" : "translate-x-full";
  const labels = directionLabels || fallbackLabels;
  let t2;
  if ($[5] !== labelId) {
    t2 = <h2 id={labelId} className="sr-only">Trip direction</h2>;
    $[5] = labelId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `absolute bottom-0 left-0 top-0 z-10 w-1/2 rounded-full bg-zinc-100 font-bold shadow ring-1 ring-zinc-200 transition-transform duration-150 ease-in-out motion-reduce:transition-none dark:bg-zinc-800 dark:shadow-none dark:ring-zinc-900 ${indicatorPosition}`;
  let t4;
  if ($[7] !== t3) {
    t4 = <div aria-hidden="true" className={t3} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== direction || $[10] !== labels.inbound || $[11] !== togglePreferredDirection) {
    t5 = <SegmentedButton label={labels.inbound} directionTo="inbound" direction={direction} togglePreferredDirection={togglePreferredDirection} />;
    $[9] = direction;
    $[10] = labels.inbound;
    $[11] = togglePreferredDirection;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== direction || $[14] !== labels.outbound || $[15] !== togglePreferredDirection) {
    t6 = <SegmentedButton label={labels.outbound} directionTo="outbound" direction={direction} togglePreferredDirection={togglePreferredDirection} />;
    $[13] = direction;
    $[14] = labels.outbound;
    $[15] = togglePreferredDirection;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== labelId || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div role="group" aria-labelledby={labelId} className="relative mx-[20px] mb-2 mt-6 flex rounded-full bg-zinc-50 text-lg dark:bg-zinc-900">{t4}{t5}{t6}</div>;
    $[17] = labelId;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t2 || $[23] !== t7) {
    t8 = <div>{t2}{t7}</div>;
    $[22] = t2;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp(el_1) {
  return getStoredStopId(el_1) && el_1.direction?.length;
}